// extracted by css-extract-rspack-plugin
export default {"button":"button-FfWq0u","closed":"closed-p2BbHz","menuItem":"menuItem-DhaqUa","expanded":"expanded-o2QKeE","text":"text-v_ueW7","floating":"floating-hEfTap"};